import { useTranslation } from "react-i18next";
import { Modal } from "@/components/ui/Modal";
import { useHelpDialog, toggleHelpDialog } from "@/lib/uiState";

interface Row {
  keys: string[];
  labelKey: string;
}

const ROWS: Row[] = [
  { keys: ["Ctrl", "K"], labelKey: "shortcuts.search" },
  { keys: ["Ctrl", "Enter"], labelKey: "shortcuts.send" },
  { keys: ["Ctrl", "N"], labelKey: "shortcuts.newDm" },
  { keys: ["Ctrl", "Shift", "L"], labelKey: "shortcuts.toggleSidebar" },
  { keys: ["Ctrl", "\\"], labelKey: "shortcuts.toggleContext" },
  { keys: ["Ctrl", "Alt", "M"], labelKey: "shortcuts.myTodos" },
  { keys: ["Ctrl", ","], labelKey: "shortcuts.settings" },
  { keys: ["/"], labelKey: "search.placeholder" },
  { keys: ["?"], labelKey: "shortcuts.help" },
  { keys: ["Esc"], labelKey: "shortcuts.esc" },
];

export function HelpDialog(): JSX.Element {
  const [open] = useHelpDialog();
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={() => toggleHelpDialog(false)}
      title={t("shortcuts.title")}
      size="md"
    >
      <ul className="space-y-2">
        {ROWS.map((row) => (
          <li
            key={row.labelKey + row.keys.join("+")}
            className="flex items-center justify-between gap-3"
          >
            <span className="text-sm text-fg-secondary">{t(row.labelKey)}</span>
            <span className="flex items-center gap-1">
              {row.keys.map((k, i) => (
                <kbd
                  key={k + i}
                  className="text-xs px-1.5 py-0.5 rounded bg-surface-raised border border-border-subtle"
                >
                  {k}
                </kbd>
              ))}
            </span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm"><a className="text-brand-700 underline" href="/help/" target="_blank" rel="noopener">使い方マニュアル（全機能の操作手順）</a></p>
    </Modal>
  );
}
